import { render } from "./BrandList.vue?vue&type=template&id=04a6be8a"
import script from "./BrandList.vue?vue&type=script&lang=js"
export * from "./BrandList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__